import React, { useState } from 'react';

const FAQSection = ({ title, icon: Icon, faqs }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-8">
      <div className="flex items-center mb-4">
        <Icon className="w-8 h-8 mr-3 text-primary" />
        <h2 className="text-2xl font-lato font-semibold text-dim">{title}</h2>
      </div>
      {faqs.map((faq, index) => (
        <div key={index} className="border-t border-gray-200 py-4">
          <button 
            onClick={() => toggleFAQ(index)}
            className="w-full flex justify-between items-center text-left focus:outline-none"
          >
            <span className="font-medium text-gray-800">{faq.question}</span>
            <span className="text-primary text-xl">
              {openIndex === index ? '−' : '+'}
            </span>
          </button>
          {openIndex === index && (
            <p className=" text-sm md:text-base mt-2 text-gray-600">{faq.answer}</p>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQSection;